// Replica los payloads que los MiniForm de flow envían a POST /api/calculate del
// microservicio calculator (flow: src/lib/miniFormPet.ts, miniFormIncendio.ts,
// miniFormRCMedica.ts y MiniFormComplementario.tsx). Los valores de `atributos`
// viajan SIEMPRE como string (schema Zod del microservicio).
import { getMiniform } from "../miniforms.js";

// El MiniForm Complementario solo pregunta cuántas cargas hay; aquí se materializan
// como hijos (fonasa) para ejercitar el modelo de cargas configurado en el plan.
export function cargasSinteticas(numCargas) {
  const n = Math.max(0, Math.min(10, Math.trunc(Number(numCargas) || 0)));
  return Array.from({ length: n }, (_, i) => ({
    nombre: `Carga ${i + 1}`,
    fechaNacimiento: "2015-01-01",
    sexo: "F",
    tipo: "hijo",
    prevision: "fonasa",
  }));
}

export function buildSimulacionPayload(miniformValue, planId, inputs = {}) {
  if (!planId) throw new Error("planId es requerido para simular (guarda el plan primero)");
  const def = getMiniform(miniformValue);
  if (!def) throw new Error(`Miniform desconocido: "${miniformValue}"`);
  if (!def.usaCalculator) throw new Error(`El miniform "${def.label}" no usa el microservicio calculator`);

  switch (miniformValue) {
    case "complementario": {
      if (!inputs.fechaNacimiento) throw new Error("Ingresa la fecha de nacimiento del titular");
      const payload = { planId, fechaNacimiento: inputs.fechaNacimiento };
      const cargas = cargasSinteticas(inputs.numCargas);
      if (cargas.length > 0) payload.cargas = cargas;
      return payload;
    }
    case "incendio": {
      if (!inputs.tipoConstruccion) throw new Error("Selecciona el tipo de construcción");
      if (!inputs.comunaCodigo) throw new Error("Selecciona la comuna");
      return {
        planId,
        atributos: { tipo_construccion: String(inputs.tipoConstruccion), comunas: String(inputs.comunaCodigo) },
      };
    }
    case "pet": {
      const n = Number(inputs.numeroMascotas);
      if (!Number.isInteger(n) || n < 1 || n > 5) throw new Error("El número de mascotas debe estar entre 1 y 5");
      return { planId, atributos: { numero_mascotas: String(n) } };
    }
    // p × q genérico: el nombre del atributo NO está fijo aquí, lo trae la config del
    // plan (cantidad.atributo) igual que en el miniform de flow. `cantidadMaximo`
    // llega por el mismo camino para reproducir el tope antes de pegarle al motor.
    case "precio_cantidad": {
      const atributo = String(inputs.cantidadAtributo || "").trim() || "cantidad";
      const n = Number(inputs.cantidad);
      if (!Number.isInteger(n) || n < 1) throw new Error("La cantidad debe ser un entero mayor o igual a 1");
      const max = Number(inputs.cantidadMaximo);
      if (Number.isInteger(max) && max >= 1 && n > max) {
        throw new Error(`La cantidad supera el máximo del plan (${max})`);
      }
      return { planId, atributos: { [atributo]: String(n) } };
    }
    case "rc_medica": {
      if (inputs.especialidad === undefined || inputs.especialidad === null || inputs.especialidad === "") {
        throw new Error("Selecciona la especialidad");
      }
      return { planId, atributos: { especialidad: String(inputs.especialidad) } };
    }
    case "monto_tasa": {
      const monto = Number(inputs.montoAsegurado);
      if (!Number.isFinite(monto) || monto <= 0) throw new Error("Ingresa el monto asegurado (UF) mayor a 0");
      return { planId, montoAsegurado: monto };
    }
    default:
      throw new Error(`Simulación no implementada para "${miniformValue}"`);
  }
}
